module.exports = __webpack_public_path__ + "img/im_wine@2x.6ba25837.png";